import { useState, useEffect } from 'react';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    console.log('🍪 CookieConsent useEffect çalıştı');
    
    const checkConsent = () => {
      try {
        const consent = localStorage.getItem('cookieConsent');
        console.log('Consent durumu:', consent);
        
        if (!consent) {
          setTimeout(() => {
            console.log('Banner gösteriliyor');
            setShowBanner(true);
          }, 1500);
        } else if (consent === 'accepted' && window.gtag) {
          window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
        }
      } catch (error) {
        console.error('Cookie consent hatası:', error);
      }
    };
    
    checkConsent();
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    if (window.gtag) {
      window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
    }
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    if (window.gtag) {
      window.gtag('consent', 'update', { 'analytics_storage': 'denied' });
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        color: 'white',
        padding: '20px',
        zIndex: 10000,
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
        <h3 style={{ margin: '0 0 10px 0', fontSize: '18px', fontWeight: 'bold' }}>
          🍪 Çerez Bildirimi
        </h3>
        <p style={{ margin: '0 0 15px 0', fontSize: '14px', lineHeight: '1.6' }}>
          Web sitemizde deneyiminizi geliştirmek için çerezler kullanıyoruz. 
          Google Analytics ile site kullanımını analiz ediyoruz. 
          KVKK ve GDPR uyumlu olarak verileriniz korunmaktadır.
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button
            onClick={handleAccept}
            style={{
              padding: '12px 30px',
              backgroundColor: '#d97706',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            ✓ Kabul Et
          </button>
          <button
            onClick={handleReject}
            style={{
              padding: '12px 30px',
              backgroundColor: 'transparent',
              color: 'white',
              border: '2px solid white',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            ✗ Reddet
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
